/* eslint-disable import/prefer-default-export */

// action types
export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
export const SET_LOCALE_START = 'SET_LOCALE_START';
export const SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS';
export const SET_LOCALE_ERROR = 'SET_LOCALE_ERROR';

// runtime variables
export const RUNTIME_MOBILE_SIDEBAR_VISIBLE = 'RUNTIME_MOBILE_SIDEBAR_VISIBLE';
export const RUNTIME_LOADING_DATA = 'RUNTIME_LOADING_DATA';
export const RUNTIME_MODAL = 'RUNTIME_MODAL';



// WEBPACK FOOTER //
// ./src/constants/index.js